import React from 'react';
import { Typography, Flex } from 'antd';

const WidgetTitle = ({ icon, title, titleConfig }) => {
  return (
    <div className='flex items-center gap-2'>
      {icon}
      <Flex align='center' gap='small' className='text-sm'>
        {titleConfig}
        <Typography className='text-sm w-full overflow-hidden text-ellipsis text-left font-bold'>
          {title || '-'}
        </Typography>
      </Flex>
    </div>
  );
};

export default WidgetTitle;
